/* import __COLOCATED_TEMPLATE__ from './mcp-actions-collapsible-list.hbs'; */
/* RESPONSIBLE TEAM: team-ml */
import Component from '@glimmer/component';
import type Action from 'embercom/models/workflow-connector/action';

interface McpActionsCollapsibleListArgs {
  title: string | null;
  target: string;
  actions: Action[];
  totalCount: number;
  selectedColumns: any[];
  loading?: boolean;
  isOpen?: boolean;
  lastPageHit?: boolean;
  mcpServerId: number | string | null;
  mcpServerName: string | null;
  onHeadingClicked: () => void;
  onAddActionClick: (mcpServerId?: string, mcpServerName?: string) => void;
}

export default class McpActionsCollapsibleList extends Component<McpActionsCollapsibleListArgs> {
  get arrowIconClass() {
    return this.args.isOpen ? 'small-thin-down-arrow' : 'small-thin-right-arrow';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::McpActionsCollapsibleList': typeof McpActionsCollapsibleList;
    'workflow-connector/mcp-actions-collapsible-list': typeof McpActionsCollapsibleList;
  }
}
